import { isValidData } from '@com-delta-idp/mnx-skymiles-shared';
import { TYPE } from '../models';
import {
  FutureActivityDisabled,
  FutureActivityRequest
} from '../models/api/future-activities.interfaces';
import { StatusTrackerResponse } from '../models/api/tracker.interfaces';

export const getFutureActivityRequest = (
  tracker: StatusTrackerResponse | undefined,
  carrierCode: string | undefined
): FutureActivityRequest | FutureActivityDisabled => {
  return isValidData<
    StatusTrackerResponse,
    [StatusTrackerResponse | undefined, string | undefined]
  >('loyaltyMemberId', tracker, carrierCode)
    ? adaptFutureActivityObject(
        tracker as StatusTrackerResponse,
        carrierCode as string
      )
    : ({} as FutureActivityDisabled);
};

const adaptFutureActivityObject = (
  tracker: StatusTrackerResponse,
  carrierCode: string
): FutureActivityRequest | FutureActivityDisabled => {
  let code = tracker.currentLoyaltyMemberMedallionStatus.find(
    (status) => status.trackingToTierLevelCode
  )?.trackingToTierLevelCode as string;

  code = code === TYPE.NOT_APPLICABLE ? TYPE.DIAMOND_MEDALLION : code;

  return tracker?.hasFutureFlights && tracker.futureFlightCnt > 0
    ? {
        carrierCode,
        loyaltyMemberId: tracker.loyaltyMemberId,
        trackingToTierLevelCode: code
      }
    : { disabled: true };
};
